import {
  LegalDocumentType,
  LocationInput,
  MutationUpdateDoorArgs,
  Provider,
  Role
} from 'graphql/generated/graphqlTypes';
import {
  ACCEPT_LEGAL_DOCUMENTS,
  ADD_LOCATION,
  ADD_REST_API_KEY,
  ADD_VISITOR_GROUP_WITH_RETAIL,
  ASSIGN_ACCESS_GRANTS_TO_DOORS,
  ASSIGN_TO_ACCESS_GRANTS,
  CHOOSE_PROVIDER,
  DELETE_DOOR_BY_ID,
  DELETE_LOCATION,
  DELETE_REST_API_KEY,
  GO_BACK_ONE_ONBOARDING_STEP,
  RESEND_VERIFICATION_CODE,
  SET_INSTALLER,
  SET_IS_ADMIN_FOR_GROUP,
  SET_MFA_PREFERENCE,
  SET_VISITOR_BY_ID,
  UNASSIGN_ACCESS_GRANTS_FROM_DOORS,
  UNASSIGN_TO_ACCESS_GRANTS,
  UNSET_INSTALLER_BY_ID,
  UPDATE_ACCESS_GRANT_WITH_IS_OFFICE_MODE_ENABLED,
  UPDATE_DOOR_WITH_LOCATIONS,
  UPDATE_DOOR_WITH_OFFICE_MODE,
  UPDATE_LOCATION,
  UPDATE_REST_API_KEY,
  UPDATE_VISITOR_GROUP_WITH_RETAIL,
  VERIFY_ACCOUNT
} from 'graphql/mutations';
import {
  ADD_VISITOR_GROUP_V2,
  ADD_VISITOR_WITH_ROLE,
  DELETE_VISITOR_BY_ID,
  DELETE_VISITOR_GROUP_BY_ID,
  SET_VISITOR_BY_ID_WITH_ROLE,
  UNREGISTER_MOBILE_DEVICE_BY_ID,
  UPDATE_ACCESS_GRANT,
  UPDATE_VISITOR_GROUP_DETAILS_V2,
  UPDATE_VISITOR_GROUP_V2
} from 'graphql/v2/mutations';
import { mockedAcceptLegalDocumentsDataForMutation1 } from 'mocks/graphqlApollo/mutation/acceptLegalDocuments';
import { mockedAddRestAPIKeyDataForMutation } from 'mocks/graphqlApollo/mutation/addRestAPIKey';
import {
  mockedChooseCognitoPrividerDataForQuery,
  mockedChooseEntraPrividerDataForQuery
} from 'mocks/graphqlApollo/mutation/chooseProvider';
import { mockedDeleteRestAPIKeyDataForMutation } from 'mocks/graphqlApollo/mutation/deleteRestAPIKey';
import { mockedSetMfaPreferenceDataForQuery } from 'mocks/graphqlApollo/mutation/setMfaPreference';
import { mockedUpdateRestAPIKeyDataForMutation } from 'mocks/graphqlApollo/mutation/updateRestAPIKey';
import {
  mockedUpdateVisitorGroupDetailsClearedMaxNumberOfMembersDataForMutation,
  mockedUpdateVisitorGroupDetailsDataForMutation
} from 'mocks/graphqlApollo/mutation/updateVisitorGroupDetails';
import { mockedVerifyCognitoUserDataForQuery } from 'mocks/graphqlApollo/mutation/verifyUserCode';
import { mockedGoBackOneOnboardingStepDataForQuery } from 'mocks/graphqlApollo/query/goBackOneOnboardingStep';
import { VisitorGroupType } from 'utils/VisitorGroup/VisitorGroup';
import { mockedAddLocationWithDoorsDataForMutation } from '../graphqlApollo/mutation/addLocationWithDoors';
import { mockedAddVisitorGroupDataForMutation } from '../graphqlApollo/mutation/addVisitorGroupCoContractor';
import {
  mockedAddVisitorWithRoleDataForMutation1,
  mockedAddVisitorWithRoleDataForMutation2
} from '../graphqlApollo/mutation/addVisitorWithRole';
import { mockedAssignAccessGrantsToDoorsDataForMutation } from '../graphqlApollo/mutation/assignAccessGrantsToDoors';
import {
  mockedAssignToAccessGrantsDataForMutation,
  mockedAssignToAccessGrantsDataForMutation1,
  mockedAssignToAccessGrantsDataForMutation2
} from '../graphqlApollo/mutation/assignToAccessGrants';
import {
  mockedDeleteDoorByIdDataForMutation,
  mockedDeleteDoorByIdDataForMutation1
} from '../graphqlApollo/mutation/deleteDoorById';
import { mockedDeleteLocationDataForMutation } from '../graphqlApollo/mutation/deleteLocation';
import { mockedDeleteVisitorByIdDataForMutation } from '../graphqlApollo/mutation/deleteVisitorById';
import { mockedDeleteVisitorGroupDataForMutation } from '../graphqlApollo/mutation/deleteVisitorGroup';
import { mockedSetInstallerDataForMutation } from '../graphqlApollo/mutation/setInstaller';
import { mockedSetIsAdminForGroupDataForMutation } from '../graphqlApollo/mutation/setIsAdminForGroup';
import {
  mockedSetVisitorDataForMutation,
  mockedUpdateInstallerDataForMutation
} from '../graphqlApollo/mutation/setVisitorById';
import { mockedSetVisitorWithRoleDataForMutation } from '../graphqlApollo/mutation/setVisitorByIdWithRole';
import { mockedUnassignAccessGrantsToDoorsDataForMutation } from '../graphqlApollo/mutation/unassignAccessGrantsToDoors';
import {
  mockedUnassignToAccessGrantsDataForMutation,
  mockedUnassignToAccessGrantsDataForMutation1,
  mockedUnassignToAccessGrantsDataForMutation2
} from '../graphqlApollo/mutation/unassignToAccessGrants';
import {
  mockedUnregisterMobileDeviceDataForMutation,
  mockedUnregisterMobileDeviceDataForMutation1
} from '../graphqlApollo/mutation/unregisterMobileDevice';
import { mockedUnsetInstallerDataDataForMutation } from '../graphqlApollo/mutation/unsetInstallerById';
import {
  mockedUpdateAccessGrantForMutation1,
  mockedUpdateAccessGrantForMutation2
} from '../graphqlApollo/mutation/updateAccessGrant';
import { mockedUpdateAccessGrantWithIsOfficeModeForMutation1 } from '../graphqlApollo/mutation/updateAccessGrantWithIsOfficeModeEnabled';
import { mockedUpdateDoorWithOfficeModeDataForMutation } from '../graphqlApollo/mutation/updateDoor';
import { mockedUpdateDoorWithLocationsDataForMutation } from '../graphqlApollo/mutation/updateDoorWithLocations';
import { mockedUpdateLocationWithDoorsDataForMutation } from '../graphqlApollo/mutation/updateLocationWithDoors';
import { mockedUpdateVisitorGroupDataForMutation } from '../graphqlApollo/mutation/updateVisitorGroup';

export const mutations = [
  {
    request: {
      query: UNREGISTER_MOBILE_DEVICE_BY_ID,
      variables: { visitorId: 'mockedAutomatedTestsUIAdminVisitorId', mobileDeviceId: 'mockedMobileDevice' }
    },
    newData: () => ({
      data: mockedUnregisterMobileDeviceDataForMutation
    })
  },
  {
    request: {
      query: UNREGISTER_MOBILE_DEVICE_BY_ID,
      variables: { visitorId: 'mockedVisitorIdExternalUser2', mobileDeviceId: 'mockedMobileDevice' }
    },
    newData: () => ({
      data: mockedUnregisterMobileDeviceDataForMutation1
    })
  },
  {
    request: {
      query: UPDATE_DOOR_WITH_OFFICE_MODE,
      variables: {
        doorId: 'mockedDoorId0',
        name: 'mockedDoorNameUpdated',
        locationId: 'mockedLocationId',
        officeMode: { scheduleType: 'weekSchedule', weekSchedule: [] }
      }
    },
    newData: () => ({
      data: {
        updateDoor: mockedUpdateDoorWithOfficeModeDataForMutation.updateDoor
      }
    })
  },
  {
    request: {
      query: DELETE_DOOR_BY_ID,
      variables: { doorId: 'mockedDoorId0' }
    },
    newData: () => ({
      data: mockedDeleteDoorByIdDataForMutation
    })
  },
  {
    request: {
      query: ASSIGN_ACCESS_GRANTS_TO_DOORS,
      variables: { doorIds: ['mockedDoorId0'], accessGrantIds: ['mockedAccessGrantId'] }
    },
    newData: () => ({
      data: mockedAssignAccessGrantsToDoorsDataForMutation
    })
  },
  {
    request: {
      query: UNASSIGN_ACCESS_GRANTS_FROM_DOORS,
      variables: { doorIds: ['mockedDoorId0'], accessGrantIds: ['mockedAccessGrantId'] }
    },
    newData: () => ({
      data: mockedUnassignAccessGrantsToDoorsDataForMutation
    })
  },
  {
    request: {
      query: UNSET_INSTALLER_BY_ID,
      variables: { visitorId: 'mockedVisitorIdInstaller1' }
    },
    newData: () => ({
      data: mockedUnsetInstallerDataDataForMutation
    })
  },
  {
    request: {
      query: DELETE_VISITOR_BY_ID,
      variables: { visitorId: 'mockedVisitorIdExternalUser1' }
    },
    newData: () => ({
      data: mockedDeleteVisitorByIdDataForMutation
    })
  },
  {
    request: {
      query: SET_VISITOR_BY_ID_WITH_ROLE,
      variables: {
        visitorId: 'mockedExternalUserId',
        name: 'mockedExternalUserName',
        visitorGroupExternalRefs: ['mockedVisitorGroupExternalRefs']
      }
    },
    newData: () => ({
      data: mockedSetVisitorDataForMutation
    })
  },
  {
    request: {
      query: SET_VISITOR_BY_ID_WITH_ROLE,
      variables: {
        visitorId: 'mockedVisitorIdExternalUser1',
        name: 'mockedVisitorNameExternalUser1AfterUpdate',
        visitorGroupExternalRefs: ['mockedVisitorGroupExternalRefs']
      }
    },
    newData: () => ({
      data: mockedSetVisitorDataForMutation
    })
  },
  {
    request: {
      query: SET_VISITOR_BY_ID_WITH_ROLE,
      variables: {
        visitorId: 'mockedVisitorIdExternalUser6',
        name: 'mockedVisitorEmailExternalUser6Edited',
        visitorGroupMembership: [
          {
            role: 'EXTERNAL_GROUP_USER',
            visitorGroupExternalRef: 'mockedVisitorGroupExternalRefs2'
          }
        ]
      }
    },
    newData: () => ({
      data: mockedSetVisitorWithRoleDataForMutation
    })
  },
  {
    request: {
      query: SET_VISITOR_BY_ID,
      variables: {
        visitorId: 'mockedVisitorIdInstaller1',
        name: 'mockedVisitorNameInstaller1Updated',
        visitorGroupExternalRefs: ['mockedVisitorGroupExternalRefsInstallers']
      }
    },
    newData: () => ({
      data: mockedUpdateInstallerDataForMutation
    })
  },
  {
    request: {
      query: SET_INSTALLER,
      variables: {
        email: 'mockedInstallerEmailNew',
        name: 'mockedInstallerNameNew'
      }
    },
    newData: () => ({
      data: mockedSetInstallerDataForMutation
    })
  },
  {
    request: {
      query: UPDATE_ACCESS_GRANT,
      variables: {
        accessGrantId: 'mockedAccessGrantWithDays',
        input: {
          scheduleType: 'weekSchedule',
          weekSchedule: [
            {
              dayName: 'monday',
              from: '08:00:00',
              to: '21:00:00'
            }
          ]
        }
      }
    },
    newData: () => ({
      data: mockedUpdateAccessGrantForMutation1
    })
  },
  {
    request: {
      query: UPDATE_ACCESS_GRANT,
      variables: {
        accessGrantId: 'mockedAccessGrantWithDays5',
        input: {
          scheduleType: 'weekSchedule',
          weekSchedule: [
            {
              dayName: 'sunday',
              from: '08:00:00',
              to: '21:00:00'
            },
            {
              dayName: 'saturday',
              from: '08:00:00',
              to: '21:00:00'
            }
          ]
        }
      }
    },
    newData: () => ({
      data: mockedUpdateAccessGrantForMutation2
    })
  },
  {
    request: {
      query: ADD_VISITOR_GROUP_WITH_RETAIL,
      variables: { name: 'co-contractors-new', maxNumberOfMembers: 2, type: VisitorGroupType.CoContractors }
    },
    newData: () => ({
      data: mockedAddVisitorGroupDataForMutation
    })
  },
  {
    request: {
      query: ADD_VISITOR_GROUP_V2,
      variables: { name: 'co-contractors-new', maxNumberOfMembers: 2, type: VisitorGroupType.CoContractors }
    },
    newData: () => ({
      data: mockedAddVisitorGroupDataForMutation
    })
  },
  {
    request: {
      query: UPDATE_VISITOR_GROUP_WITH_RETAIL,
      variables: {
        name: 'co-contractors1',
        visitorGroupId: 'mockedVisitorGroupIdExternalUsers1',
        maxNumberOfMembers: 3
      }
    },
    newData: () => ({
      data: mockedUpdateVisitorGroupDataForMutation
    })
  },
  {
    request: {
      query: UPDATE_VISITOR_GROUP_V2,
      variables: {
        name: 'co-contractors1',
        visitorGroupId: 'mockedVisitorGroupIdExternalUsers1',
        maxNumberOfMembers: 3
      }
    },
    newData: () => ({
      data: mockedUpdateVisitorGroupDataForMutation
    })
  },
  {
    request: {
      query: UPDATE_VISITOR_GROUP_DETAILS_V2,
      variables: {
        input: {
          visitorGroupId: 'mockedVisitorGroupIdExternalUsers1',
          name: 'co-contractors1',
          maxNumberOfMembers: 3,
          isQrCodeVisitInviter: false,
          officeMode: {
            accessGrantId: 'mockedAccessGrantId1',
            isOfficeModeEnabled: false
          }
        }
      }
    },
    newData: () => ({
      data: mockedUpdateVisitorGroupDetailsDataForMutation
    })
  },
  {
    request: {
      query: UPDATE_VISITOR_GROUP_DETAILS_V2,
      variables: {
        input: {
          visitorGroupId: 'mockedVisitorGroupIdExternalUsers1',
          name: 'co-contractors1',
          maxNumberOfMembers: null,
          isQrCodeVisitInviter: false,
          officeMode: {
            accessGrantId: 'mockedAccessGrantId1',
            isOfficeModeEnabled: false
          }
        }
      }
    },
    newData: () => ({
      data: mockedUpdateVisitorGroupDetailsClearedMaxNumberOfMembersDataForMutation
    })
  },
  {
    request: {
      query: ADD_VISITOR_WITH_ROLE,
      variables: {
        email: 'mockedExternalUserEmail',
        name: 'mockedExternalUserName',
        visitorGroupMembership: [
          {
            role: Role.ExternalGroupUser,
            visitorGroupId: 'mockedVisitorGroupIdExternalUsers4'
          }
        ]
      }
    },
    newData: () => ({
      data: mockedAddVisitorWithRoleDataForMutation1
    })
  },
  {
    request: {
      query: ADD_VISITOR_WITH_ROLE,
      variables: {
        name: 'mockedVisitorEmailExternalUser6Edited',
        email: 'mockedVisitorEmailExternalUser6Edited',
        visitorGroupMembership: [
          {
            role: 'EXTERNAL_GROUP_USER',
            visitorGroupExternalRef: 'mockedVisitorGroupExternalRefs2'
          }
        ]
      }
    },
    newData: () => ({
      data: mockedAddVisitorWithRoleDataForMutation2
    })
  },
  {
    request: {
      query: DELETE_VISITOR_GROUP_BY_ID,
      variables: {
        visitorGroupId: 'mockedVisitorGroupId1',
        withVisitors: true
      }
    },
    newData: () => ({
      data: mockedDeleteVisitorGroupDataForMutation
    })
  },
  {
    request: {
      query: SET_IS_ADMIN_FOR_GROUP,
      variables: {
        visitorGroupId: 'mockedVisitorGroupId1',
        isAdmin: true
      }
    },
    newData: () => ({
      data: mockedSetIsAdminForGroupDataForMutation
    })
  },
  {
    request: {
      query: UPDATE_ACCESS_GRANT_WITH_IS_OFFICE_MODE_ENABLED,
      variables: {
        accessGrantId: 'mockedAccessGrantId1',
        isOfficeModeEnabled: false
      }
    },
    newData: () => ({
      data: mockedUpdateAccessGrantWithIsOfficeModeForMutation1
    })
  },
  {
    request: {
      query: DELETE_DOOR_BY_ID,
      variables: { doorId: 'mockedDoorId1' }
    },
    newData: () => ({
      data: mockedDeleteDoorByIdDataForMutation1
    })
  },
  {
    request: {
      query: ADD_LOCATION,
      variables: { location: { doorIds: [], name: 'mockedLocationName' } as LocationInput }
    },
    newData: () => ({
      data: mockedAddLocationWithDoorsDataForMutation
    })
  },
  {
    request: {
      query: UPDATE_LOCATION,
      variables: {
        id: 'mockedLocationId0',
        location: { doorIds: [], name: 'mockedUpdatedLocationName' } as LocationInput
      }
    },
    newData: () => ({
      data: mockedUpdateLocationWithDoorsDataForMutation
    })
  },
  {
    request: {
      query: DELETE_LOCATION,
      variables: { id: 'mockedAddedLocationId' }
    },
    newData: () => ({
      data: mockedDeleteLocationDataForMutation
    })
  },
  {
    request: {
      query: UPDATE_DOOR_WITH_LOCATIONS,
      variables: {
        doorId: 'mockedDoorId0',
        locationIds: undefined,
        name: 'mockedDoorNameUpdated',
        officeMode: { scheduleType: 'weekSchedule', weekSchedule: [] }
      } as MutationUpdateDoorArgs
    },
    newData: () => ({
      data: mockedUpdateDoorWithLocationsDataForMutation
    })
  },
  {
    request: {
      query: ASSIGN_TO_ACCESS_GRANTS,
      variables: {
        accessGrantIds: ['mockedAccessGrantId0'],
        doorIds: [],
        locationIds: ['mockedLocationId']
      }
    },
    newData: () => ({
      data: mockedAssignToAccessGrantsDataForMutation
    })
  },
  {
    request: {
      query: ASSIGN_TO_ACCESS_GRANTS,
      variables: {
        accessGrantIds: ['mockedAccessGrantId0'],
        doorIds: ['mockedDoorId0'],
        locationIds: []
      }
    },
    newData: () => ({
      data: mockedAssignToAccessGrantsDataForMutation1
    })
  },
  {
    request: {
      query: ASSIGN_TO_ACCESS_GRANTS,
      variables: {
        accessGrantIds: ['mockedAccessGrantId0', 'mockedAccessGrantId1', 'mockedAccessGrantId2'],
        doorIds: ['mockedDoorId0'],
        locationIds: []
      }
    },
    newData: () => ({
      data: mockedAssignToAccessGrantsDataForMutation2
    })
  },
  {
    request: {
      query: UNASSIGN_TO_ACCESS_GRANTS,
      variables: {
        accessGrantIds: ['mockedAccessGrantId0'],
        doorIds: [],
        locationIds: ['mockedLocationId']
      }
    },
    newData: () => ({
      data: mockedUnassignToAccessGrantsDataForMutation
    })
  },

  {
    request: {
      query: UNASSIGN_TO_ACCESS_GRANTS,
      variables: {
        accessGrantIds: ['mockedAccessGrantId0'],
        doorIds: ['mockedDoorId0'],
        locationIds: []
      }
    },
    newData: () => ({
      data: mockedUnassignToAccessGrantsDataForMutation1
    })
  },
  {
    request: {
      query: UNASSIGN_TO_ACCESS_GRANTS,
      variables: {
        accessGrantIds: ['mockedAccessGrantId0'],
        doorIds: [],
        locationIds: ['mockedLocationId']
      }
    },
    newData: () => ({
      data: mockedUnassignToAccessGrantsDataForMutation
    })
  },
  {
    request: {
      query: UNASSIGN_TO_ACCESS_GRANTS,
      variables: {
        accessGrantIds: ['mockedAccessGrantId0', 'mockedAccessGrantId1', 'mockedAccessGrantId2'],
        doorIds: ['mockedDoorId0'],
        locationIds: []
      }
    },
    newData: () => ({
      data: mockedUnassignToAccessGrantsDataForMutation2
    })
  },
  {
    request: {
      query: ACCEPT_LEGAL_DOCUMENTS,
      variables: {
        dpa: {
          documentType: LegalDocumentType.Dpa,
          versionHash: 'DPAVersionHash',
          acceptedVersion: 'mockedCurrentVersion'
        },
        sla: {
          documentType: LegalDocumentType.Sla,
          versionHash: 'SLAVersionHash',
          acceptedVersion: 'mockedCurrentVersion'
        }
      }
    },
    newData: () => ({
      data: mockedAcceptLegalDocumentsDataForMutation1
    })
  },
  {
    request: {
      query: ACCEPT_LEGAL_DOCUMENTS,
      variables: {
        dpa: 'DPAid',
        sla: 'SLAid'
      }
    },
    newData: () => ({
      data: {}
    })
  },
  {
    request: {
      query: ADD_REST_API_KEY,
      variables: {
        description: 'mockedAddedRestAPIKeyName'
      }
    },
    newData: () => ({
      data: mockedAddRestAPIKeyDataForMutation
    })
  },
  {
    request: {
      query: UPDATE_REST_API_KEY,
      variables: {
        id: 'mockedRestApiKeyId',
        description: 'updatedName'
      }
    },
    newData: () => ({
      data: mockedUpdateRestAPIKeyDataForMutation
    })
  },
  {
    request: {
      query: DELETE_REST_API_KEY,
      variables: {
        id: 'mock-key-1'
      }
    },
    newData: () => ({
      data: mockedDeleteRestAPIKeyDataForMutation
    })
  },
  {
    request: {
      query: CHOOSE_PROVIDER,
      variables: {
        provider: Provider.Cognito
      }
    },
    newData: () => ({
      data: mockedChooseCognitoPrividerDataForQuery
    })
  },
  {
    request: {
      query: CHOOSE_PROVIDER,
      variables: {
        provider: Provider.Entra
      }
    },
    newData: () => ({
      data: mockedChooseEntraPrividerDataForQuery
    })
  },
  {
    request: {
      query: GO_BACK_ONE_ONBOARDING_STEP
    },
    newData: () => ({
      data: mockedGoBackOneOnboardingStepDataForQuery
    })
  },
  {
    request: {
      query: VERIFY_ACCOUNT,
      variables: {
        email: 'email@email.com',
        code: '000000'
      }
    },
    newData: () => ({
      data: mockedVerifyCognitoUserDataForQuery
    })
  },
  {
    request: {
      query: GO_BACK_ONE_ONBOARDING_STEP
    },
    newData: () => ({
      data: mockedGoBackOneOnboardingStepDataForQuery
    })
  },
  {
    request: {
      query: RESEND_VERIFICATION_CODE,
      variables: {
        email: 'mock email'
      }
    },
    newData: () => ({
      data: null
    })
  },
  {
    request: {
      query: SET_MFA_PREFERENCE,
      variables: {
        emailMfaEnabled: false
      }
    },
    newData: () => ({
      data: mockedSetMfaPreferenceDataForQuery
    })
  }
];
